"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChipStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../style/commons/_colors");
exports.useChipStyles = (0, core_1.makeStyles)(function () { return ({
    root: {
        maxWidth: '100%',
        color: _colors_1.darkBlue,
        backgroundColor: _colors_1.lightBlue,
        paddingLeft: 4,
        paddingRight: 3,
        '&:hover': {
            backgroundColor: _colors_1.lightLightBlue,
        },
        '&:focus': {
            backgroundColor: _colors_1.lightBlue,
        },
        '& .MuiChip-deleteIcon': {
            color: _colors_1.mediumLightBlue,
        },
    },
    disabled: {
        backgroundColor: _colors_1.lightGrey,
        color: _colors_1.mediumLightBlue,
        opacity: '1 !important',
        '& .MuiChip-deleteIcon': {
            color: _colors_1.mediumGrey,
        },
    },
}); });
